import styled from 'styled-components';

import { COLORS } from '../../../theme/tokens';
import { Text } from '../../../components';

/** Muted one-line description under a section title — shared by the page's sections. */
export const SectionSubtitle = styled(Text)`
  display: block;
  margin: -4px 0 16px;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;
